import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const Location = React.forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor = '#212121', ...props }, ref) => {
    return (
      <Svg
        ref={ref}
        width={24}
        height={24}
        fill='none'
        viewBox='0 0 24 24'
        {...props}
      >
        <Path
          d='M5.843 4.568a8.707 8.707 0 1112.314 12.314l-1.187 1.174c-.875.858-2.01 1.962-3.406 3.312a2.25 2.25 0 01-3.128 0l-3.491-3.396c-.439-.431-.806-.794-1.102-1.09a8.707 8.707 0 010-12.314zm11.253 1.06A7.207 7.207 0 106.904 15.822L8.39 17.29a753.98 753.98 0 003.088 3 .75.75 0 001.043 0l3.394-3.3c.47-.461.863-.85 1.18-1.168a7.207 7.207 0 000-10.192zM12 7.999a3.002 3.002 0 110 6.004A3.002 3.002 0 0112 8zm0 1.5a1.501 1.501 0 100 3.004A1.501 1.501 0 0012 9.5z'
          fill={fillColor}
        />
      </Svg>
    )
  }
)

Location.displayName = 'Location'

export default Location
